import React, { Component } from 'react'
import { OrderListStyle } from './style'
import OrderItem from '../OrderItem'
import _ from 'lodash'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getPartialSteps } from 'components/Steps/thunk'
import { setStepsToDefault } from 'components/Steps/slices'
import CheckOrderIdPopup from '../modal'
import { FormattedMessage } from 'react-intl'
import { PopupWindow } from 'components/Modal'
import { getOrders } from '../../thunk'
import { updateOrders } from '../../slices'
import { SS } from '../../../../utils/common'
import {
	showScrollButton,
	hideScrollButton,
} from 'components/ScrollButton/slice'

class ListItem extends Component {
	constructor() {
		super()
		this.state = {
			modal: '',
			scroll: 0,
		}
		this.isHeightObserverActive = false
	}

	setOrderModal = (data) =>
		this.setState({
			modal: data,
		})

	checkFlowItems = () => {
		let { items } = this.props
		let selectedOrderId
		for (let i in items) {
			if (!_.isEmpty(items[i]) && i !== 'newExchange') {
				const key = Object.keys(items[i])[0]
				selectedOrderId = items[i][key]?.orderId
			}
		}
		return selectedOrderId
	}

	firstScroll = () => {
		let interval = setInterval(checkItem, 300)

		function checkItem() {
			// eslint-disable-next-line no-unused-expressions
			let item = document.querySelector('[data-index="open"]')
			if (item) {
				let checker = document.querySelector('[data-index="checker"]')
				if (checker) {
					checker.scrollIntoView({
						block: 'center',
						behavior: 'smooth',
					})
					stopScroll()
				}
			}
		}

		function stopScroll() {
			clearInterval(interval)
		}

		setTimeout(() => {
			stopScroll()
		}, 5000)
	}

	initHeightObserver() {
		if (!this.isHeightObserverActive) {
			let self = this
			const resize_ob = new ResizeObserver(function (entries) {
				// since we are observing only a single element, so we access the first element in entries array
				let rect = entries[0].contentRect

				// current height
				let height = rect.height
				let windowHeight = window.innerHeight

				if (height > windowHeight) {
					self.props.showScrollButton()
				} else {
					self.props.hideScrollButton()
				}
			})
			resize_ob.observe(document.querySelector('.overflowed'))
			this.isHeightObserverActive = true
		}
	}

	checkScrollBarBottom = () => {
		let scrollHeight = document.body.scrollHeight
		let totalHeight = window.scrollY + window.innerHeight
		if (totalHeight >= scrollHeight) {
			this.props.hideScrollButton()
		} else {
			this.props.showScrollButton()
		}
	}

	componentDidMount() {
		this.props.getOrders(this.checkFlowItems())
		this.firstScroll()
	}

	componentDidUpdate(prevProps, prevState, snapshots) {
		let { partialRequestData, isLoading, orders } = this.props
		if (prevProps.partialRequestData !== partialRequestData) {
			if (partialRequestData) {
				console.log('flowSteps', 'Orders')
				this.props.getPartialSteps(partialRequestData)
			} else {
				this.props.setStepsToDefault()
			}
		}

		if (
			prevProps.isLoading !== isLoading &&
			isLoading === false &&
			orders &&
			orders.length
		) {
			setTimeout(() => {
				let defaultLoginOrderNumber = SS.get('loginOrderId')
				if (defaultLoginOrderNumber) {
					setTimeout(() => {
						SS.remove('loginOrderId')
						let defaultScrollElement = document.getElementById(
							defaultLoginOrderNumber
						)
						if (defaultScrollElement) {
							defaultScrollElement.scrollIntoView({
								block: 'start',
								behavior: 'smooth',
							})
						}
					}, 0)
				} else {
					let openedOrder = document.querySelector(
						'[data-index="open"]'
					)
					if (openedOrder && openedOrder.id) {
						let openedOrderElement = document.getElementById(
							openedOrder.id
						)
						let checkedReturnItem =
							openedOrderElement.querySelector(
								'[data-cheker="checker"]'
							)

						if (checkedReturnItem) {
							checkedReturnItem.scrollIntoView({
								block: 'start',
								behavior: 'smooth',
							})
						} else {
							openedOrderElement.scrollIntoView({
								block: 'start',
								behavior: 'smooth',
							})
						}
					}
				}
			}, 0)
		}

		if (this.props.orders && prevProps.orders !== this.props.orders) {
			this.initHeightObserver()
			window.addEventListener('scroll', this.checkScrollBarBottom)
		}
	}

	render() {
		let { orders, items, isFlowLoading } = this.props
		let { modal } = this.state

		return (
			<>
				<PopupWindow
					open={!!modal}
					onClose={() => this.setOrderModal('')}
					content={
						<CheckOrderIdPopup
							orderId={modal}
							onClose={() => this.setOrderModal('')}
						/>
					}
					title={
						<FormattedMessage
							id='orders.choose.other.warning.title'
							defaultMessage='DO YOU WANT TO LEAVE THIS ORDER?'
						/>
					}
				/>
				<OrderListStyle>
					{orders?.map((item) => {
						let defaultLoginOrderNumber = SS.get('loginOrderId')
						let isOpenByDefault =
							item.orderExternalId === defaultLoginOrderNumber

						return (
							<OrderItem
								id={item.orderExternalId}
								key={item.orderExternalId + item.count}
								item={item}
								isOpenByDefault={isOpenByDefault}
								isOpenState={
									isOpenByDefault ? true : item.isOpen
								}
								checkFlowItems={this.checkFlowItems}
								setOrderModal={this.setOrderModal}
								itemsFlow={items}
								isFlowLoading={isFlowLoading}
							/>
						)
					})}
				</OrderListStyle>
				{/*<div className='flex justify-content-center pb-4'>
					<ButtonFull
						onClick={() => alert('functionality is not ready')}
						uppercase='true'
						dark
					>
						LOAD MORE ORDERS
					</ButtonFull>
				</div>*/}
			</>
		)
	}
}

function mapStateToProps({ root, steps, orders }) {
	return {
		...root,
		...steps,
		...orders,
	}
}

function matchDispatchToProps(dispatcher) {
	return bindActionCreators(
		{
			getOrders,
			getPartialSteps,
			setStepsToDefault,
			updateOrders,
			showScrollButton,
			hideScrollButton,
		},
		dispatcher
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(ListItem)
